import { NavLink } from "react-router-dom";
import { FiHome, FiShoppingBag, FiBarChart2, FiFileText, FiX } from "react-icons/fi";

const linkClass =
  "flex items-center gap-3 rounded-lg px-4 py-3 text-sm hover:bg-[#e0d8c3]/30 text-[#000000] transition min-h-[44px]";

const activeClass = "bg-[#e0d8c3]/40 text-[#000000] font-medium";

const Sidebar = ({ isOpen, onClose }) => {
  return (
    <>
      <aside
        className={`fixed top-0 left-0 z-50 h-full w-64 min-h-screen border-r border-[#a6a6a6]/30 bg-white p-4 transition-transform duration-200 ease-out md:relative md:z-0 md:translate-x-0 md:shrink-0 ${
          isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        }`}
      >
        <div className="flex items-center justify-between mb-4 md:mb-0 md:invisible">
          <span className="text-sm font-medium text-[#000000]">Menu</span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Mbyll menunë"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-[#000000] hover:bg-[#a6a6a6]/20"
          >
            <FiX size={20} />
          </button>
        </div>

        <nav className="space-y-1">
          <NavLink
            to="/admin"
            end
            onClick={onClose}
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FiHome size={18} />
            Kryefaqja
          </NavLink>

          <NavLink
            to="/admin/orders"
            onClick={onClose}
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FiShoppingBag size={18} />
            Porositë
          </NavLink>

          <NavLink
            to="/admin/stats"
            onClick={onClose}
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FiBarChart2 size={18} />
            Përmbledhje porosish
          </NavLink>

          <NavLink
            to="/admin/content"
            onClick={onClose}
            className={({ isActive }) =>
              `${linkClass} ${isActive ? activeClass : ""}`
            }
          >
            <FiFileText size={18} />
            Përmbajtja
          </NavLink>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
